module.exports = __webpack_public_path__ + "static/portfolio1-9de084f9b3e6d4eeace7e2e900c313fc.jpg";